import {useDropzone} from 'react-dropzone'
import React, {useCallback, useEffect, useState} from 'react';
import _ from 'lodash'

export default function FileDropzone(props) {
    const onDrop = useCallback(acceptedFiles => {
      if(props.onDropFile){
        props.onDropFile(acceptedFiles)
      }
    }, [props.data])
    const [fileName, setFileName] = useState(undefined)
    useEffect(() => {
      if(!props.tempFile) return;
      for (const entry of props.tempFile.entries()) {
        const [name, value] = entry;
        if (value instanceof File) {
          setFileName(value.name)
          console.log(value.name)
        }
      }
    },[props.tempFile])
    const {getRootProps, getInputProps, isDragActive} = useDropzone({onDrop})
  
    return (
      <div className='cursor-pointer' {...getRootProps()} style={{width:'100%',height:'100%',justifyContent:'center',alignItems:'center',display:'flex',flexDirection:'column'}}>
        <input {...getInputProps()} />
        <UploadSvg/>
        <div style={{fontSize:16,marginTop:5,color:'#A1A1A1'}}>{fileName ? `上傳${fileName}` : '拖動文件上傳'}</div>
        <div className='bg-[#00E9BA] font-[700] rounded-[7px] px-[12px] py-[8px] text-[#425596]'>
          {fileName ? '重新選擇文件' : '選擇文件'}
        </div>
        <div style={{fontSize:14,color:'#737373'}}>PNG、PDF、JPG  最大 {props.maxMB||2}MB</div>
        {/*
          isDragActive ?
            <p>Drop the files here ...</p> :
            <p></p>
        */}
      </div>
    )
  }



  function UploadSvg(props) {
    return (
      <svg
        width={32}
        height={34}
        viewBox="0 0 32 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M8.112 23.152c-3.596 0-6.51-2.802-6.51-6.259 0-2.984 2.172-5.48 5.079-6.108a7.562 7.562 0 01-.197-1.716c0-4.321 3.643-7.824 8.138-7.824 3.937 0 7.221 2.688 7.975 6.26l.162-.001c4.494 0 8.138 3.503 8.138 7.824 0 3.785-2.796 6.943-6.51 7.668m-3.255-4.538l-4.883-4.695m0 0l-4.882 4.695m4.882-4.695v18.778"
          stroke="#171717"
          strokeWidth={1.67}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }